<template>
  <div>
    <div class="e-item eDetailElement col-12 col-md-12">
      <strong style="font-size: 24px;">Add Equipment Help</strong>
    </div>
    <div class="e-item eDetailElement col-12 col-md-12" style="margin-bottom: 3%;">
      Equipment Registration applications must be submitted for the installation of air pollution sources such as combustion (heating) equipment, process (manufacturing) equipment, air pollution control equipment and storage tanks in suburban and unincorporated Cook County.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12" style="margin-bottom: 3%;">
      Register all the air emission equipment even if they are defined as “Insignificant Sources” by Illinois EPA. For example, boiler under 10 MMBH is required to register with Cook County Department of Environment and Sustainability.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12" style="font-weight: bold;">
      Additional Application Information:
    </div>
    <div class="e-item eDetailElement col-12 col-md-12">
      In addition to all the boilers/furnaces/heaters under “Fuel Burning” the following facilities must also register:
    </div>
    <div class="e-item eDetailElement col-12 col-md-12">
      Restaurant: “Cooking Area” under “Processing”.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12">
      Dry Cleaners: “Dry Cleaner Machines” under “Processing”.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12">
      Dry Cleaners: “Dry Cleaner Machines” under “Processing”.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12">
      Gas Station: “Storage Tanks” under “Storage Tanks”.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12" style="margin-bottom: 3%;">
      Data Center: Emergency generators under “Fuel Burning” and fuel tanks under “Storage Tanks”.
    </div>
    <div class="e-item eDetailElement col-12 col-md-12">
      For additional information on equipment installation application requirements and fees, refer to Sections 30-151 through 30-164 and Section 32-1 of the Municipal Code.
      If you have any questions please email <strong>equipmentregistration@cookcountyil.gov</strong> or call at (312) 603-8200 option 3.
    </div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentDetailsFAQ',
  data() {
  },

};

</script>
